import { render } from "./UserMenu.vue?vue&type=template&id=69312daa"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script